<template>
  <Modal ref="modalRef" class="sharing-limit-reached-modal" @ok="showPlansPage">
    <template #title>Sharing limit reached</template>
    <div>
      You have reached the sharing limit for your current plan.
    </div>
    <div class="limit-details">
      <label>Current plan:</label>     
      <div>{{ planRef?.displayName }}</div>
      <label>Sharing limit:</label>     
      <div class="value">
        <span class="count">{{ sharingLimitRef }}</span> users
      </div>
    </div>
    <div class="help-text">
        This is the total number of unique users or invited users in all the groups you own, 
        except groups that are only sharing trees that are "free to share".
    </div>
    <template #okText>
      <img src="@/assets/icons/rocket_500.png" class="upgrade-icon"/>
      Upgrade plan
    </template>
  </Modal>
</template>

<style lang="scss" scoped>
:deep(.modal-body) {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.limit-details {
  margin-left: 1rem;
  display: grid;
  grid-template-columns: max-content 1fr;
  column-gap: 1.5rem;
  align-items: baseline;

  .value {
    font-size: 0.875rem;
    color: #888;
  }

  .count {
    font-size: 1.5rem;
    color: black;
  }
}

.upgrade-icon {
  margin-right: 0.25rem;
  width: 24px;
  filter: invert(1);
}
</style>

<script lang="ts" setup>
import { computed, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useSharingLimiter } from './SharingLimiter'
import { useModalAutoHide } from '@/util/AppUtil'
import { useUserStore } from '@/gp/UserStore'
import { useSubscriptionStore } from '@/gp/SubscriptionStore'
import { LoadMode } from '@/util/AsyncData'
import { defaultPlanId, subscriptionPlans } from '@/gp/GroupAdminModel'
import Modal from '@/util/Modal.vue'

defineExpose({
  open: () => modalRef.value?.open(),
})

const modalRef = ref<InstanceType<typeof Modal>>()

const userStore = useUserStore()
const subscriptionStore = useSubscriptionStore()
const sharingLimiter = useSharingLimiter()
const router = useRouter()
useModalAutoHide(modalRef)

const sharingLimitRef = computed(() => userStore.getAsyncSelf()?.data?.limits?.sharingLimit ?? 0)
const subRef = computed(() => subscriptionStore.getSubscriptionListForSelf(LoadMode.EnsureLoaded).at(0))
const priceRef = computed(() => subRef.value?.items.at(0)?.price)
const planRef = computed(() => subscriptionPlans.find(p => p.id == (priceRef.value?.productId ?? defaultPlanId)))

async function showPlansPage() {
  router.push("/plans")
}
</script>
